import { render, staticRenderFns } from "./member-tag.vue?vue&type=template&id=1c7550d8&scoped=true&"
import script from "./member-tag.vue?vue&type=script&lang=js&"
export * from "./member-tag.vue?vue&type=script&lang=js&"
import style0 from "./member-tag.vue?vue&type=style&index=0&id=1c7550d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7550d8",
  null
  
)

export default component.exports